export default __webpack_public_path__ + "static/media/aboutPic.5ca35e88.jpg";